const getTranslatePosition = ($element: HTMLElement) => {
  const { transform } = window.getComputedStyle($element);
  const matrix = new DOMMatrixReadOnly(transform);

  return { x: matrix.m41, y: matrix.m42 };
};

export default getTranslatePosition;
